import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_inventory_by_lot_selection_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, fullTextSearch?: string }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string } }, Packaging?: { ShortName?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_inventory_by_lot_selection_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string } }, Packaging?: { ShortName?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_inventory_by_lot_selection_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseId: number, materialId?: number, packagingId?: number, lotId?: number, projectId: number, fullTextSearch?: string, $keys: { WarehouseId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, PackagedAmount?: number, Lot?: { LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string } }, Packaging?: { ShortName?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_inventory_by_lot_selection_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
